import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import install from "./config/install";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import "./style/base.less";
import "./style/theme.less";
import "./assets/icon/iconfont.css";
import "./config/other";
import "./common/filters";
import Component from "vue-class-component";
Component.registerHooks([
  "beforeRouteEnter", //进入路由之前
  "beforeRouteLeave", //离开路由之前
  "beforeRouteUpdate"
]);
import i18n from "./config/i18n";

Vue.config.productionTip = false;
Vue.use(ViewUI, {
  i18n: function (path: any, options: any) {// eslint-disable-line
    const value = i18n.t(path, options);
    if (value !== null && value !== undefined) return value;
    return "";
  }
});
Vue.use(install);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
